import React, { createContext, useReducer, useEffect, useMemo } from 'react';
import { sportalokaClient } from '../api/sportaloka-client';

export const AuthContext = createContext();

const initialState = {
  accessToken: '',
  refreshToken: '',
  sessionId: '',
  userProfile: '',
  init_loading: true
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_INIT':
      return {
        ...state,
        init_loading: action.payload
      };
    case 'SIGNIN':
      sportalokaClient.defaults.headers.common['Authorization'] = action.payload.accessToken;
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        userProfile: action.payload.userProfile,
        sessionId: action.payload.sessionId
      };
    case 'SIGNOUT':
      delete sportalokaClient.defaults.headers.common['Authorization'];
      localStorage.removeItem('accessToken');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('userProfile');
      localStorage.removeItem('refreshToken');
      return {
        ...initialState,
        init_loading: false
      };
    default:
      return state;
  }
};

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    async function fetchCookie() {
      const accessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      const sessionId = localStorage.getItem('sessionId');
      const userProfile = localStorage.getItem('userProfile');
      const profile = userProfile ? JSON.parse(userProfile) : null;
      dispatch({
        type: 'SIGNIN',
        payload: {
          accessToken: accessToken ?? '',
          refreshToken: refreshToken ?? '',
          sessionId: sessionId ?? '',
          userProfile: profile
        }
      });
      dispatch({
        type: 'SET_INIT',
        payload: false
      });
    }
    fetchCookie();
  }, []);

  useEffect(() => {
    if (state.accessToken) {
      localStorage.setItem('accessToken', state.accessToken);
    }

    if (state.refreshToken) {
      localStorage.setItem('refreshToken', state.refreshToken);
    }

    if (state.sessionId) {
      localStorage.setItem('sessionId', state.sessionId);
    }

    if (state.userProfile) {
      localStorage.setItem('userProfile', JSON.stringify(state.userProfile));
    }
  }, [state]);

  const value = useMemo(() => [state, dispatch], [state, dispatch]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
